import { Dialog } from "@mui/material";
import QISignTheme from "../../../interfaces/Theme";
import * as S from './styles';
import darkOrLightMode from "../../../utils/helpers/colorMode";
import { ThemedButton } from "../../../components/ThemedButton";
import { Cross2Icon } from "@radix-ui/react-icons";

export const ErrorDialog = ({
    description,
    onClose,
    clientThemeSettings
} : {
    description: string,
    onClose: () => void,
    clientThemeSettings: QISignTheme
}) => {

    let errorMessage = "Os dados recebidos estão incorretos."

    switch (description) {
        case "incorrect_personal_data":
            errorMessage = "Os dados recebidos estão incorretos."
            break;
        case "invalid_data":
            errorMessage = "Os dados pessoais estão inválidos."
            break
        case "terms_not_checked":
            errorMessage = "É necessário concordar com os termos de uso para iniciar a assinatura."
            break
        default:
            errorMessage = "Os dados recebidos estão incorretos."
            break;
    } 

    return (
        <Dialog
            maxWidth="xs"
            open={description.length > 0}
            onClose={onClose} 
            keepMounted={false}
        >
            <S.Container>
                <S.Header $backgroundColor={clientThemeSettings.background_color}>
                    <S.Title $colorMode={darkOrLightMode(clientThemeSettings.background_color)}>
                        Erro
                    </S.Title>
                    <S.IconFrame onClick={onClose}>
                        <Cross2Icon width={24} height={24} color={darkOrLightMode(clientThemeSettings.background_color) === 'light mode' ? '#232323' : '#fff'}/>
                    </S.IconFrame>
                </S.Header>
                <S.DescriptionContainer>
                    <S.Description>{errorMessage}</S.Description>
                </S.DescriptionContainer>
                <S.ButtonContainer>
                    <ThemedButton
                        clientThemeSettings={clientThemeSettings}
                        loading={false}
                        onClick={onClose}
                    >
                        Continuar
                    </ThemedButton>
                </S.ButtonContainer>
            </S.Container>
        </Dialog>
    )
}